import React from 'react';

const Refresh = () => (
    <svg width="12px" height="17px" viewBox="0 0 12 17" version="1.1" xmlns="http://www.w3.org/2000/svg">
        <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
            <g id="Group-3" transform="translate(0.000000, 0.500000)" fill="#0852E0" fillRule="nonzero">
                <g id="Group" transform="translate(0.000000, 2.900000)">
                    <path
                        d="M6,0.6 L6,2.6 C3.790861,2.6 2,4.390861 2,6.6 C2,8.809139 3.790861,10.6 6,10.6 C8.209139,10.6 10,8.809139 10,6.6 C10,6.01259888 9.87338495,5.45477029 9.64595806,4.95231744 L11.4692472,4.12916142 C11.8101925,4.88266261 12,5.71916535 12,6.6 C12,9.9137085 9.3137085,12.6 6,12.6 C2.6862915,12.6 -3.55271368e-15,9.9137085 -3.55271368e-15,6.6 C-3.55271368e-15,3.2862915 2.6862915,0.6 6,0.6 L6,0.6 Z"
                        id="Combined-Shape"
                    ></path>
                </g>
                <g id="Group-2" transform="translate(3.900000, 0.000000)">
                    <polygon
                        id="Combined-Shape"
                        points="0.0857864376 1.5 1.5 0.0857864376 5.91421356 4.5 1.5 8.91421356 0.0857864376 7.5 2.09174501 5.49418422 2.11966862 3.53373741"
                    ></polygon>
                </g>
            </g>
        </g>
    </svg>
);

export default Refresh;
